import React, { useState, useCallback } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { LoadingButton } from "@mui/lab";

export default function useContextMenu(items = []) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentObj, setCurrentObj] = useState(null);
  const open = Boolean(anchorEl);

  const openMenu = useCallback((event, obj) => {
    // event.preventDefault(); // PAS stopPropagation !
    setCurrentObj(obj);
    setAnchorEl(event.currentTarget);
  }, []);

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const MenuComponent = () => (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={closeMenu}
      onClick={closeMenu}
    >
      {items.map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            // closeMenu();
            item.action(currentObj);
          }}
        >
          <LoadingButton
            startIcon={
              item.icon && (
                <ListItemIcon>
                  {React.isValidElement(item.icon)
                    ? React.cloneElement(item.icon, {
                        color: item.color || "primary",
                      })
                    : item.icon}
                </ListItemIcon>
              )
            }
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ color: item.color || "primary" }}
            />
          </LoadingButton>
        </MenuItem>
      ))}
    </Menu>
  );

  return { openMenu, MenuComponent };
}
